import * as React from "react";

export const SidebarContext = React.createContext<{ open: boolean }>(undefined as any)
export const SidebarContextProvider = SidebarContext.Provider
export const SidebarContextConsumer = SidebarContext.Consumer